import { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { ColumnSetting } from './column-setting'
import { ResultCount } from '../components/result-count'
import { ResultTable } from '../components/result-table'
import { Pagination } from '../components/pagination'
import {
  changePage,
  toggleSort,
  requestDownload,
  changeStatus,
  changeContactPerson,
  deleteCompanyStatus,
  deleteCompanyContactPerson,
  updateColumns,
  updateCompanyMemo,
  updateCompanyFirstInterviewDate,
  deleteCompanyFirstInterviewDate,
  Company,
} from '../actions'
import { SortableField } from '../constants/orders'
import { css } from '@emotion/react'
import { LoadingOverlay } from '../../../atoms/LoadingOverlay'
import { DownloadButton } from '../components/download-button'
import { colors } from 'plume-ui'
import { Cover } from '../../../common/Cover'
import { CompanyStatusesOptionDropDown } from '../components/company-statuses-option-drop-down'
import { CompanyContactPersonsOptionDropDown } from '../components/company-contact-persons-option-drop-down'
import { ShareUrl } from './share-url'
import { User } from '../../../../types'
import { SourcingAnnotationPanel } from '../components/molucule/SourcingAnnotationPanel'
import { CompanyFirstInterviewDateCalender } from '../components/company-firstInterview-date-calender'
import { CompanyContactPerson, Status } from '../../../../types/api'
import { ColumnName, ColumnState, getColumnNames } from '../reducers/column'
import { ContactPersonsState } from '../reducers/contactPerson'
import {
  ConditionState,
  SourcingRouteId,
  StatusConditionState,
} from '../reducers/condition'
import { useRouter } from 'next/router'
import {
  MyLabelId,
  SourcingAnnotationsCandidatesState,
  SourcingRoute,
} from '../reducers/sourcingAnnotationCandidates'
import {
  changeSourcingRoute,
  createSourcingRoute,
  deleteSourcingRoute,
  detouchCompanySourcingRoute,
  putCompanyMyLabel,
  deleteCompanyMyLabel,
  updateSourcingRoute,
  createMyLabel,
  updateMyLabel,
  deleteMyLabel,
  refreshSourcingAnnotationCandidates,
} from '../actions/sourcingAnnotation'
import { useUser } from '@/contexts/AuthContext'
import { SourcingAnnotationCandidateEditModal } from '../components/SourcingAnnotationCandidateEditModal'
import { fetchCompanies } from '../actions'
import { trackEvent } from '@/lib/tracking'

export type SelectedStatusRow = {
  companyId: string
  selectedStatusName: string | null | undefined
  target: HTMLTableCellElement
}

export type SelectedContactPersonRow = {
  companyId: string
  selectedContactPersonFirstName: string | null | undefined
  selectedContactPersonLastName: string | null | undefined
  target: HTMLTableCellElement
}

export type SelectedFirstInterviewDateRow = {
  shortName: string
  selectedFirstInterviewDate: Date
  target: HTMLTableCellElement
}

// ソーシングルート選択状態の行の情報
export type SelectedCompanySourcingRouteRow = {
  shortName: string // ソーシングルート選択状態の企業の shortName
  target: HTMLTableCellElement | HTMLButtonElement
  selectedSourcingRoute: SourcingRoute | null | undefined
}

const SearchResult = (props: {
  handleColmunSetting: (names: ColumnName[]) => void
  onPageChange: (offset: number, page: number) => void
  onToggleSort: (name: SortableField) => void
  onDownload: () => void
  onSelectStatus: (
    id: string,
    companyId: string,
    name: string,
    user: User
  ) => void
  onSelectContactPerson: (
    id: ContactPersonsState['data'][0]['id'],
    companyId: string,
    firstName: ContactPersonsState['data'][0]['firstName'],
    lastName: ContactPersonsState['data'][0]['lastName'],
    user: User
  ) => void
  onSelectStatusBlank: (companyId: string, user: User) => void
  onSelectContactPersonBlank: (companyId: string, user: User) => void
  onUpdateMemo: (companyId: string, memo: string) => void
  onSelectFirstInterviewDate: (
    companyId: string,
    firstInterviewDate: string,
    user: User
  ) => void
  onSelectFirstInterviewDateBlank: (companyId: string, user: User) => void
  onSelectSourcingRoute: (
    companyId: string,
    sourcingRouteId: number,
    sourcingRouteName: string,
    user: User
  ) => void
  onDeselectSourcingRoute: (companyId: string, user: User) => void
  onCreateSourcingRoute: (sourcingRouteName: string) => void
  onUpdateSourcingRouteName: (id: number, name: string) => void
  onDeleteSourcingRoute: (id: number) => void
  onSelectMyLabel: (
    companyId: string,
    myLabelIds: MyLabelId,
    user: User
  ) => void
  onDeselectMyLabel: (
    companyId: string,
    myLabelIds: MyLabelId,
    user: User
  ) => void
  onCreateMyLabel: (myLabelName: string) => void
  onUpdateMyLabelName: (id: MyLabelId, name: string) => void
  onDeleteMyLabel: (id: MyLabelId) => void
  limit: number
  offset: number
  page: number
  sorting: { sort: SortableField; order: 'asc' | 'desc' }
  count: number
  data: Company[]
  columns: ColumnState
  condition: ConditionState
  statusCondition: StatusConditionState
  role: string
  restricted: boolean
  allowed: boolean
  latestPlan: boolean
  earlyAccess: boolean
  searching: boolean
  downloading: boolean
  errors: any[]
  statuses: Status[]
  contactPersons: ContactPersonsState['data']
  sourcingAnnotationsCandidatesState: SourcingAnnotationsCandidatesState
}) => {
  const user = useUser()
  const [selectedCompanyStatus, setSelectedCompanyStatus] =
    useState<SelectedStatusRow | null>(null)
  const [selectedCompanyContactPerson, setSelectedCompanyContactPerson] =
    useState<SelectedContactPersonRow | null>(null)
  const [
    selectedCompanyFirstInterviewDate,
    setSelectedCompanyFirstInterviewDate,
  ] = useState<SelectedFirstInterviewDateRow | null>(null)
  const [isHiddenColumnSettingModal, setIsHiddenColumnSettingModal] =
    useState(true)
  const [
    isHiddenSourcingRouteCandidateModal,
    setIsHiddenSourcingRouteCandidateModal,
  ] = useState(true)
  const [isHiddenMyLabelCandidateModal, setIsHiddenMyLabelCandidateModal] =
    useState(true)

  const router = useRouter()
  const dispatch = useDispatch()

  const getColumnSetting = () => {
    const columnNamesHash = getColumnNames(props.latestPlan, props.earlyAccess)
    const initialColumnNames = Object.keys(columnNamesHash)
      .filter((key) => {
        // @ts-ignore
        return columnNamesHash[key].selected
      })
      .sort(
        (a: string, b: string) =>
          // @ts-ignore
          columnNamesHash[a].displayOrder - columnNamesHash[b].displayOrder
      )

    // クエリに fields の指定がある場合、他の場所で column のセットがされているので、
    // ここでは column セッティングをいじらない
    const query = router.query['fields']
    if (typeof query === 'string') {
      const queryArray = query.split(',')
      queryArray !== initialColumnNames
      return
    }

    // ユーザーが保存したカラム設定がある場合、それを優先して使う
    const columnSetting = localStorage.getItem('column_setting')
    if (columnSetting) {
      props.handleColmunSetting(columnSetting.split(',') as ColumnName[])
      return
    }

    // permission によって初期選択の列を変更する
    props.handleColmunSetting(initialColumnNames as ColumnName[])
  }

  useEffect(() => {
    getColumnSetting()
  }, [props.latestPlan, props.earlyAccess])

  useEffect(() => {
    dispatch(fetchCompanies())
    dispatch(refreshSourcingAnnotationCandidates())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [selectedCompanyShortname, setSelectedCompanyShortname] = useState<
    string | undefined
  >(undefined)

  const isPanelOpened = () => selectedCompanyShortname !== undefined

  const openPanel = (v: string) => setSelectedCompanyShortname(v)

  const closePanel = () => setSelectedCompanyShortname(undefined)

  const handleSourcingRouteModalClose = () => {
    setIsHiddenSourcingRouteCandidateModal(true)
  }

  const handleMyLabelModalClose = () => {
    setIsHiddenMyLabelCandidateModal(true)
  }

  const handleSelectSourcingRoute = (
    companyId: string,
    sourcingRouteId: SourcingRouteId,
    sourcingRouteName: string
  ) => {
    props.onSelectSourcingRoute(
      companyId,
      sourcingRouteId.id,
      sourcingRouteName,
      user
    )
  }

  const handleDeselectSourcingRoute = (companyId: string) => {
    props.onDeselectSourcingRoute(companyId, user)
  }

  const handleRequestEditSourcingRouteModal = () => {
    setIsHiddenSourcingRouteCandidateModal(false)
  }

  const handleSelectMyLabel = (myLabelId: MyLabelId, companyId: string) => {
    props.onSelectMyLabel(companyId, myLabelId, user)
  }

  const handleDeselectMyLabel = (myLabelId: MyLabelId, companyId: string) => {
    props.onDeselectMyLabel(companyId, myLabelId, user)
  }

  const handleRequestEditMyLabelModal = () => {
    setIsHiddenMyLabelCandidateModal(false)
  }

  return (
    <>
      <LoadingOverlay active={props.searching} />
      <div>
        <div
          className="search-result-header"
          css={css`
            height: 56px;
            display: flex;
            justify-content: space-between;
          `}
        >
          <ResultCount value={props.count} />
          <div
            className="header-buttons"
            css={css`
              display: flex;
              align-items: center;
            `}
          >
            <ColumnSetting
              isHidden={isHiddenColumnSettingModal}
              onOpen={() => setIsHiddenColumnSettingModal(false)}
              onClose={() => setIsHiddenColumnSettingModal(true)}
            />
            <ShareUrl />
            <LoadingOverlay
              active={props.downloading}
              styles={{
                spinner: (base: any) => ({
                  ...base,
                  width: '1em',
                  height: '1em',
                  margin: 0,
                  '& svg circle': {
                    stroke: colors.gray70,
                    strokeWidth: 10,
                    opacity: 0.5,
                  },
                }),
                overlay: (base: any) => ({
                  ...base,
                  background: 'transparent',
                }),
              }}
            >
              <DownloadButton
                resultCount={props.count}
                downloadLimit={1000}
                isLoading={props.downloading}
                allowed={
                  props.role === 'moderator' ||
                  (props.role === 'enterprise' && props.allowed)
                }
                enterprise={
                  props.role === 'moderator' || props.role === 'enterprise'
                }
                restricted={props.role !== 'moderator' && props.restricted}
                onClick={() => {
                  trackEvent(user, '企業一覧のダウンロード')
                  props.onDownload()
                }}
              />
            </LoadingOverlay>
          </div>
        </div>
        {props.count > 0 ? (
          <>
            <ResultTable
              companies={props.data}
              sorting={props.sorting}
              columns={props.columns}
              candidates={props.sourcingAnnotationsCandidatesState}
              onToggle={props.onToggleSort}
              condition={props.condition}
              statusCondition={props.statusCondition}
              selectedCompanyStatus={selectedCompanyStatus}
              setSelectedCompanyStatus={setSelectedCompanyStatus}
              selectedCompanyContactPerson={selectedCompanyContactPerson}
              setSelectedCompanyContactPerson={setSelectedCompanyContactPerson}
              selectedCompanyFirstInterviewDate={
                selectedCompanyFirstInterviewDate
              }
              setSelectedCompanyFirstInterviewDate={
                setSelectedCompanyFirstInterviewDate
              }
              onTriggerEditStatus={openPanel}
              selectedCompanyShortname={selectedCompanyShortname}
              onSelectSourcingRoute={handleSelectSourcingRoute}
              onDeselectSourcingRoute={handleDeselectSourcingRoute}
              onRequestEditSourcingRouteModal={
                handleRequestEditSourcingRouteModal
              }
              onSelectMyLabel={handleSelectMyLabel}
              onDeselectMyLabel={handleDeselectMyLabel}
              onRequestEditMyLabelModal={handleRequestEditMyLabelModal}
            />
            {(selectedCompanyStatus != null ||
              selectedCompanyContactPerson != null ||
              selectedCompanyFirstInterviewDate != undefined) && (
              <Cover
                handleClick={() => {
                  setSelectedCompanyStatus(null)
                  setSelectedCompanyContactPerson(null)
                  setSelectedCompanyFirstInterviewDate(null)
                }}
              />
            )}
            {
              // TODO: name ではなく id で突き合わせる
            }
            <CompanyStatusesOptionDropDown
              selectedCompanyStatus={selectedCompanyStatus}
              setSelectedCompanyStatus={setSelectedCompanyStatus}
              statuses={props.statuses}
              onSelectStatusBlank={props.onSelectStatusBlank}
              onSelectStatus={props.onSelectStatus}
            />
            {
              // TODO: name ではなく id で突き合わせる
            }
            <CompanyContactPersonsOptionDropDown
              selectedCompanyContactPerson={selectedCompanyContactPerson}
              setSelectedCompanyContactPerson={setSelectedCompanyContactPerson}
              contactPersons={props.contactPersons}
              onSelectContactPersonBlank={props.onSelectContactPersonBlank}
              onSelectContactPerson={props.onSelectContactPerson}
            />
            {selectedCompanyFirstInterviewDate ? (
              <div
                css={css`
                  position: absolute;
                  z-index: 2;
                  top: ${selectedCompanyFirstInterviewDate.target.getBoundingClientRect()
                    .top +
                  window.pageYOffset +
                  37}px;
                  left: ${selectedCompanyFirstInterviewDate.target.getBoundingClientRect()
                    .left + window.pageXOffset}px;
                  margin-top: 16px;
                `}
              >
                <CompanyFirstInterviewDateCalender
                  shortName={selectedCompanyFirstInterviewDate.shortName}
                  firstInterviewDate={
                    selectedCompanyFirstInterviewDate.selectedFirstInterviewDate
                  }
                  onSelectFirstInterviewDateBlank={(
                    companyId: string,
                    user: User
                  ) => {
                    setSelectedCompanyFirstInterviewDate(null)
                    props.onSelectFirstInterviewDateBlank(companyId, user)
                  }}
                  onSelectFirstInterviewDate={(
                    companyId: string,
                    firstInterviewDate: string,
                    user: User
                  ) => {
                    setSelectedCompanyFirstInterviewDate(null)
                    props.onSelectFirstInterviewDate(
                      companyId,
                      firstInterviewDate,
                      user
                    )
                  }}
                />
              </div>
            ) : (
              <></>
            )}
          </>
        ) : (
          <div
            className="result-table is-empty"
            css={css`
              text-align: center;
              color: #d9d9d9;
              font-size: 22px;
              vertical-align: middle;
              line-height: 200px;
              border-top: 1px solid #d9d9d9;
            `}
          >
            検索結果が見つかりませんでした
          </div>
        )}
        <div
          className="u-justify-center u-my10 u-flex-row"
          css={css`
            padding-block: 8px;
          `}
        >
          <Pagination
            limit={props.limit}
            offset={props.offset}
            total={props.count}
            onChange={props.onPageChange}
            page={props.page}
          />
        </div>
      </div>
      <SourcingAnnotationPanel
        isOpen={isPanelOpened()}
        companyShortname={selectedCompanyShortname}
        myLabels={props.sourcingAnnotationsCandidatesState.myLabels}
        sourcingRoutes={props.sourcingAnnotationsCandidatesState.sourcingRoutes}
        onSelectStatus={(companyId: string, status: Status, user: User) => {
          props.onSelectStatus(status.id, companyId, status.name, user)
        }}
        onSelectStatusBlank={props.onSelectStatusBlank}
        onSelectContactPerson={(
          companyContactPerson: CompanyContactPerson,
          user: User
        ) => {
          props.onSelectContactPerson(
            companyContactPerson.userId,
            companyContactPerson.companyId,
            companyContactPerson.firstName || '',
            companyContactPerson.lastName || '',
            user
          )
        }}
        onSelectContactPersonBlank={props.onSelectContactPersonBlank}
        onSelectMyLabel={handleSelectMyLabel}
        onDeselectMyLabel={handleDeselectMyLabel}
        onRequestEditMyLabelModal={handleRequestEditMyLabelModal}
        onSelectFirstInterviewDate={props.onSelectFirstInterviewDate}
        onSelectFirstInterviewDateBlank={props.onSelectFirstInterviewDateBlank}
        onSelectSourcingRoute={props.onSelectSourcingRoute}
        onDeselectSourcingRoute={handleDeselectSourcingRoute}
        onRequestEditSourcingRouteModal={handleRequestEditSourcingRouteModal}
        onUpdateMemo={props.onUpdateMemo}
        closePanel={closePanel}
      />
      <SourcingAnnotationCandidateEditModal
        isHidden={isHiddenSourcingRouteCandidateModal}
        modalId="sourcing-route"
        modalName="ソーシングルート"
        onCreate={props.onCreateSourcingRoute}
        onUpdate={props.onUpdateSourcingRouteName}
        onDelete={props.onDeleteSourcingRoute}
        onClose={handleSourcingRouteModalClose}
      >
        {props.sourcingAnnotationsCandidatesState.sourcingRoutes}
      </SourcingAnnotationCandidateEditModal>
      <SourcingAnnotationCandidateEditModal
        isHidden={isHiddenMyLabelCandidateModal}
        modalId="my-label"
        modalName="マイラベル"
        onCreate={props.onCreateMyLabel}
        onUpdate={props.onUpdateMyLabelName}
        onDelete={props.onDeleteMyLabel}
        onClose={handleMyLabelModalClose}
      >
        {props.sourcingAnnotationsCandidatesState.myLabels}
      </SourcingAnnotationCandidateEditModal>
    </>
  )
}

const mapStateToProps = (state: any) => ({
  limit: state.condition.limit,
  offset: state.condition.offset,
  page: state.condition.page,
  sorting: { sort: state.condition.sort, order: state.condition.order },
  count: state.result.count,
  data: state.result.data,
  columns: state.column,
  condition: state.condition,
  statusCondition: state.statusCondition,
  role: state.permission.role,
  restricted: state.permission.restricted,
  allowed: state.permission.allowed,
  latestPlan: state.permission.latestPlan,
  earlyAccess: state.permission.earlyAccess,
  searching: state.app.searching,
  downloading: state.app.downloading,
  errors: state.error.errors,
  statuses: state.statuses.data,
  contactPersons: state.contactPersons.data,
  sourcingAnnotationsCandidatesState: state.sourcingAnnotationsCandidates,
})

const mapDispatchToProps = (dispatch: any) => ({
  handleColmunSetting: (names: ColumnName[]) => {
    dispatch(updateColumns(names))
  },
  onPageChange: (offset: number, page: number) => {
    dispatch(changePage({ offset, page }))
  },
  onToggleSort: (name: SortableField) => {
    dispatch(toggleSort(name))
  },
  onDownload: () => {
    dispatch(requestDownload())
  },

  onSelectStatus: (id: string, companyId: string, name: string, user: User) => {
    dispatch(changeStatus({ id, companyId, name, user }))
  },
  onSelectContactPerson: (
    id: number,
    companyId: string,
    firstName: string,
    lastName: string,
    user: User
  ) => {
    dispatch(changeContactPerson({ id, companyId, firstName, lastName, user }))
  },
  onSelectStatusBlank: (companyId: string, user: User) => {
    dispatch(deleteCompanyStatus({ companyId, user }))
  },
  onSelectContactPersonBlank: (companyId: string, user: User) => {
    dispatch(deleteCompanyContactPerson({ companyId, user }))
  },
  onUpdateMemo: (companyId: string, memo: string) => {
    dispatch(updateCompanyMemo({ companyId, memo }))
  },
  onSelectFirstInterviewDate: (
    companyId: string,
    firstInterviewDate: string,
    user: User
  ) => {
    dispatch(
      updateCompanyFirstInterviewDate({ companyId, firstInterviewDate, user })
    )
  },
  onSelectFirstInterviewDateBlank: (companyId: string, user: User) => {
    dispatch(deleteCompanyFirstInterviewDate({ companyId, user }))
  },
  onSelectSourcingRoute: (
    companyId: string,
    sourcingRouteId: number,
    sourcingRouteName: string,
    user: User
  ) => {
    dispatch(
      changeSourcingRoute({
        companyId,
        sourcingRouteId,
        sourcingRouteName,
        user,
      })
    )
  },
  onDeselectSourcingRoute: (companyId: string, user: User) => {
    dispatch(
      detouchCompanySourcingRoute({
        companyId,
        user,
      })
    )
  },
  onCreateSourcingRoute: (sourcingRouteName: string) => {
    dispatch(createSourcingRoute({ sourcingRouteName }))
  },
  onUpdateSourcingRouteName: (id: number, name: string) => {
    dispatch(updateSourcingRoute({ id, name }))
  },
  onDeleteSourcingRoute: (id: number) => {
    dispatch(deleteSourcingRoute({ id }))
  },
  onSelectMyLabel: (companyId: string, myLabelId: MyLabelId, user: User) => {
    dispatch(putCompanyMyLabel({ companyId, myLabelId, user }))
  },
  onDeselectMyLabel: (companyId: string, myLabelId: MyLabelId, user: User) => {
    dispatch(deleteCompanyMyLabel({ companyId, myLabelId, user }))
  },
  onCreateMyLabel: (name: string) => {
    dispatch(createMyLabel({ name }))
  },
  onUpdateMyLabelName: (id: MyLabelId, name: string) => {
    dispatch(updateMyLabel({ id, name }))
  },
  onDeleteMyLabel: (id: MyLabelId) => {
    dispatch(deleteMyLabel({ id }))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchResult)
